import React, { useMemo, useRef } from 'react';

import { useToggle } from 'react-use';

import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { Menu } from '@infoods/lifebase-ui';

import classes from './SidebarMenu.module.scss';
import { SidebarItem } from '../SidebarItem/SidebarItem';
import {
  CollapseMenuItem,
  SidebarMenuItem,
} from '../../../../interfaces/system/SidebarNavConfig';
import { useIsActivePage } from '../../../../hooks/useIsActivePage';
import { useSidebarContext } from '../../hooks/SidebarContext';
import { SidebarMenuElement } from './SidebarMenuElement/SidebarMenuElement';
import { getNavigationIcon } from '../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';

type SidebarMenuProps = {
  item: SidebarMenuItem | CollapseMenuItem;
  onItemClick?: () => void;
};

const SidebarMenu = ({ item, onItemClick }: SidebarMenuProps) => {
  const { icon, label, items: options } = item;
  const { isCollapsed } = useSidebarContext();
  const ref = useRef<HTMLButtonElement>(null);
  const [isOpen, toggleOpen] = useToggle(false);

  const pathList = useMemo(() => options.map((option) => option.path), [options]);
  const isActive = useIsActivePage({ urls: pathList });

  return (
    <>
      <SidebarItem
        as="button"
        ref={ref}
        onClick={toggleOpen}
        startIcon={getNavigationIcon(icon)}
        label={label}
        endIcon={<KeyboardArrowRightRoundedIcon />}
        active={isOpen || !!isActive}
        activeHighlight
        collapsed={isCollapsed}
      />
      <Menu
        anchorEl={ref.current}
        open={isOpen}
        onClick={toggleOpen}
        anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
        transformOrigin={{ horizontal: 'left', vertical: 'center' }}
        slotProps={{
          paper: { className: classes.paper },
          list: { component: 'div', className: classes.list },
        }}
      >
        {options.map((option) => (
          <SidebarMenuElement item={option} key={option.label} onClick={onItemClick} />
        ))}
      </Menu>
    </>
  );
};

export { SidebarMenu };
